// packages/web-ui/src/panels/chat-panel/ThinkingIndicator.tsx
//
// W2-S5 AC #7 — "Thinking…" indicator. Three pulsing dots with staggered
// `animate-bounce` delays. Reduced-motion makes the dots static.

import type { JSX } from 'react';

export interface ThinkingIndicatorProps {
  visible: boolean;
}

export function ThinkingIndicator({ visible }: ThinkingIndicatorProps): JSX.Element | null {
  if (!visible) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Assistant is thinking"
      data-testid="thinking-indicator"
      className="flex items-center gap-1 px-4 py-3 text-sm italic text-taupe-700"
    >
      <span>Thinking…</span>
      <span className="ml-2 inline-flex items-center gap-1">
        <span
          className="inline-block h-1.5 w-1.5 rounded-full bg-taupe-700 motion-safe:animate-bounce motion-reduce:animate-none"
          style={{ animationDelay: '50ms' }}
        />
        <span
          className="inline-block h-1.5 w-1.5 rounded-full bg-taupe-700 motion-safe:animate-bounce motion-reduce:animate-none"
          style={{ animationDelay: '100ms' }}
        />
        <span
          className="inline-block h-1.5 w-1.5 rounded-full bg-taupe-700 motion-safe:animate-bounce motion-reduce:animate-none"
          style={{ animationDelay: '150ms' }}
        />
      </span>
    </div>
  );
}
